module.exports = __webpack_public_path__ + "media/images/career_camp/2022/texts/step_2-d2c5c6e7223d2a4a1cec9362baf6f7e9.svg";